module.exports = __webpack_public_path__ + "img/feedback_card.77a4d804.png";